import Box, { BoxProps } from '@totallymoney/ui/components/Box'

const Flex = ({ children, ...props }: BoxProps) => {
    return (
        <Box {...props} display="flex">
            {children}
        </Box>
    )
}

export default Flex
